/* global WP */

import domRouter from './modules/domRouter'
import $ from 'jquery'
import 'slick-carousel';
import 'salvattore';
import map from './modules/map'
import objectFit from 'object-fit-images'
import photoswipeGallery from './modules/photoswipe/photoswipeGallery'
import Vue from 'vue'
import vueRouter from './modules/vueRouter'
import vueApp from './modules/app.vue'
import stickyElement from './modules/stickyElement'
import mobileMenu from './modules/mobileMenu'
import plyr from 'plyr'
import cookieNotice from './modules/cookieNotice'
import getParameterByName from './utils/getParameterByName'
import Tracking from './modules/Tracking'

domRouter
    .add('all', () => {
        objectFit();

        // Cache DOM
        const $$ = {
            headerWrapper: $('.js--header-wrapper'),
            header: $('.js--header'),
            logo: $('.js--logo'),
            adminBar: $('#wpadminbar'),
            scrollUpLink: $('.js--scroll-link')
        };

        // Calculations
        const adminBarHeight = $$.adminBar.length === 0 ? 0 : $$.adminBar.outerHeight();
        const siteHeaderHeight = $$.header.outerHeight();
        const stickyHeaderOffset = adminBarHeight + siteHeaderHeight;
        const arrowOffset = adminBarHeight + siteHeaderHeight;

        // Init
        const stickyHeaderWrapper = stickyElement();
        const stickyHeader = stickyElement();
        const stickyLogo = stickyElement();
        const arrow = stickyElement();
        const mainMenu = mobileMenu({
            button: '.js--menu-button',
            menu: '.js--menu'
        }, {
            activeClass: 'site-header__menu-wrap--active'
        });
        const tracking = new Tracking();

        // Run
        stickyHeaderWrapper
            .init({
                $el: $$.headerWrapper,
                activeClass: 'site__header--sticky',
                inactiveClass: 'site__header--static',
                offset: stickyHeaderOffset,
                relativeTo: $$.header
            })
            .run();

        stickyHeader
            .init({
                $el: $$.header,
                activeClass: 'site-header--sticky',
                inactiveClass: 'site-header--static',
                offset: stickyHeaderOffset,
            })
            .run();

        stickyLogo
            .init({
                $el: $$.logo,
                activeClass: 'logo--sticky',
                inactiveClass: 'logo--static',
                offset: stickyHeaderOffset,
                relativeTo: $$.header
            })
            .run();

        arrow
            .init({
                $el: $$.scrollUpLink,
                activeClass: 'scroll-link--visible',
                inactiveClass: 'scroll-link--static',
                offset: arrowOffset,
            })
            .run();

        mainMenu.run();

        cookieNotice({
            button: '#js--accept-cookies',
            container: '#js--cookies'
        }, {
            accepted: 'cookies--accepted',
            hidden: 'cookies--hidden'
        })
            .run();

        $$.scrollUpLink.on('click', (e) => {
            e.preventDefault();
            const target =  $($$.scrollUpLink.attr('href'));
            window.scrollTo(0, target.offset().top);
        });

        tracking
            .addTrackingCode('google_analytics', WP.apis.googleAnalytics, () => {
                (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
                    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
                })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

                ga('create', WP.apis.googleAnalytics, 'auto');
                ga('send', 'pageview');
            })
            .init()
    })
    .add('page-template-front-page', () => {
        const $$ = {
            slider: $('#js--slider'),
            dotsContainer: $('#js--dots'),
            arrowsContainer: $('#js--arrows')
        };

        $$.slider.slick({
            dots: true,
            autoplay: false,
            arrows: true,
            speed: 750,
            appendDots: $$.dotsContainer,
            appendArrows: $$.arrowsContainer,
            zIndex: 1
        });
    })
    .add('page-template-branches', () => {
        const $$ = {
            map: $('#js--map'),
            branches: $('.js--branch-name'),
        };

        const activeClass = 'contact__company-name--active';

        const findBranchByLatLng = (latLng) => {
            return $$.branches.filter((index, branch) => {
                console.log(branch);
                const { lat, lng } = $(branch).data();
                return latLng.lat === lat && latLng.lng === lng;
            });
        }

        const markers = map($$.map, {
            // Łódź
            lat: 51.759445,
            lng: 19.457216,
        }, WP.branchesMarkers);

        markers.on('mouseOver', (event, { lat, lng }) => {
            const $branch = findBranchByLatLng({ lat, lng });
            $branch.addClass(activeClass);
        })

        markers.on('mouseOut', () => {
            $$.branches.removeClass(activeClass)
        })
    })
    .add('tax-project-category', () => {
        const $el = $('#js--category');
        const data = $el.data();
        const router = vueRouter.init();

        new Vue({
            router,
            el: $el[0],
            render: createElement => createElement(vueApp, {
                props: {
                    categoryName: data.categoryName,
                    taxonomy: data.taxonomy,
                    termId: data.termId
                }
            })
        });
    })
    .add([
        'single-project',
        'page-template-text-and-gallery'
    ], () => {
        const $$ = {
            gallery: $('.js--gallery'),
            videos: $('.js--video')
        };

        const playerSettings = {
            controls: [
                'fullscreen',
                'progress',
                'mute',
                'play'
            ],
            loadSprite: false,
            autoplay: false,
            clickToPlay: true,
            showPosterOnEnd: true,
            keyboardShortcuts: {
                focused: false,
                global: false
            },
            tooltips: {
                controls: false,
                seek: false
            }
        };

        $$.videos.each((index, video) => {

            const url = $(video).data('video-id');
            const time = parseInt(getParameterByName('t', url), 10) || 0;
            const player = plyr.setup(video, playerSettings);
            let sought = false;

            if (player.length === 0) {
                return;
            }

            const p = player[0];

            p.on('ready', function () {
                if (p.isMuted()) {
                    return;
                }
                p.setVolume(0);
            });

            p.on('play', function () {
                if (time && !sought) {
                    p.seek(time);
                    sought = true; // A workaround that makes it run only once. plyr doesn't have an .off method, so there's no elegant solution.
                }
            });

        });

        $$.gallery.each((galleryIndex, galleryEl) => {
            const gallery = photoswipeGallery();
            const $images = $('.js--image', $(galleryEl));

            $images.each((index, imageEl) => {
                $(imageEl).data({
                    galleryIndex,
                    index
                });
            });

            gallery.init($images);
            gallery.run();
        });

    })
    .add([
      'page-template-employees',
      'page-template-branches',
      'page-template-billing-information',
      'page-template-about-us-child',
      'page-template-text-and-gallery',
      'single-employee',
      'tax-project-category'
    ], () => {
        const subMenu = mobileMenu({
            button: '.js--sub-menu-button',
            menu: '.js--sub-menu'
        }, {
            activeClass: 'sub-menu--active'
        });

        subMenu.run();
    });

domRouter.run();



// WEBPACK FOOTER //
// ./src/js/app.js